import { allAvailableEventTypes, BOOKING_SESSION_STATUS_MAP } from 'src/consumer/constants'

export const FLOW_STATUSES_FOR_LEAVING_SESSION = {
  continue: 'continue',
  stop: 'stop',
}

export function getInitialSection({
  defaultTabToOpenOnOpeningACompletedSession,
  bInfoEventType,
  tabItems,
  auxiliaryData,
  bookedEventInfo,
}) {
  let defaultTabForCompletedSession
  if (
    !!defaultTabToOpenOnOpeningACompletedSession &&
    tabItems?.some((item) => item?.id === defaultTabToOpenOnOpeningACompletedSession)
  ) {
    defaultTabForCompletedSession = tabItems?.find(
      (item) => item?.id === defaultTabToOpenOnOpeningACompletedSession,
    )
  }

  const getTabSection = getMethodForGettingSection({
    sessionStatus: bookedEventInfo?.sessionStatus,
    defaultTabForCompletedSession,
  })

  return getTabSection({ tabItems, eventType: bInfoEventType, auxiliaryData })
}

function getMethodForGettingSection({ sessionStatus, defaultTabForCompletedSession }) {
  switch (sessionStatus) {
    case BOOKING_SESSION_STATUS_MAP['marked-completed']:
      if (defaultTabForCompletedSession) {
        return () => defaultTabForCompletedSession
      }
      return getCompletedSessionSection
    case BOOKING_SESSION_STATUS_MAP.finished:
      return getOngoingSessionSection
    case BOOKING_SESSION_STATUS_MAP['in-progress']:
      return getOngoingSessionSection
    case BOOKING_SESSION_STATUS_MAP['not-started']:
      return getNotStartedSessionSection
    default:
      return getNotStartedSessionSection
  }
}

function getCompletedSessionSection({ tabItems, eventType, auxiliaryData }) {
  switch (eventType) {
    case allAvailableEventTypes.consultation:
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.screening:
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.therapySession:
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.assessment:
      return tabItems?.find((item) => item?.id === 'patient_history')
    default:
      return tabItems?.find((item) => item?.id === 'patient_history')
  }
}
function getNotStartedSessionSection({ tabItems, eventType, auxiliaryData }) {
  switch (eventType) {
    case allAvailableEventTypes.consultation:
      if (auxiliaryData?.screeningReport) {
        return tabItems?.find((item) => item?.id === 'consultation_screening_report')
      }
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.screening:
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.therapySession:
      return tabItems?.find((item) => item?.id === 'patient_history')
    case allAvailableEventTypes.assessment:
      return tabItems?.find((item) => item?.id === 'assessment_report') || tabItems?.find((item) => item?.id === 'patient_history')
    default:
      return tabItems?.find((item) => item?.id === 'patient_history')
  }
}
function getOngoingSessionSection({ tabItems, eventType, auxiliaryData }) {
  return null
  //   switch (eventType) {
  //     case allAvailableEventTypes.consultation:
  //       return tabItems?.find((item) => item?.id === 'patient_history')
  //     case allAvailableEventTypes.screening:
  //       return tabItems?.find((item) => item?.id === 'patient_history')
  //     case allAvailableEventTypes.therapySession:
  //       return tabItems?.find((item) => item?.id === 'patient_history')
  //     default:
  //       return tabItems?.find((item) => item?.id === 'patient_history')
  //   }
}
